import { Request } from '@konv/http'
import { UserStorage } from 'shared/tools/UserStorage';

export class OAuthAPI {

    static async request({ endpoint = '/', method = 'GET', headers = {}, query = {}, data = {} }) {
        return await Request.request({
            endpoint: endpoint,
            cors: true,
            method: method || 'GET',
            headers: headers || {},
            service: 'oauth',
            ignoreVersion: true,
            params: query || {},
            data: data || {}
        });
    }

    static async requestAuthenticated({ endpoint = '/', method = 'GET', query, data }) {
        return await OAuthAPI.request({
            endpoint,
            headers: { 'Authorization': 'Bearer ' + UserStorage.getAccessToken() },
            method,
            query,
            data,
        });
    }

    static async authorize() {
        return await OAuthAPI.request({
            endpoint: '/authorize',
            method: 'POST',
            data: {
                APPLICATION_ID: process.env.REACT_APP_APPLICATION_ID,
                APPLICATION_SECRET: process.env.REACT_APP_APPLICATION_SECRET
            }
        });
    }

    static async authenticate(username, password) {

        const authorizationResponse = await OAuthAPI.authorize();
        const authorizationToken = authorizationResponse.getData({ access_token: null }).access_token;

        if (!authorizationToken) {
            return null;
        }

        return await OAuthAPI.request({
            endpoint: '/authenticate',
            method: 'POST',
            headers: { Authorization: 'Bearer ' + authorizationToken },
            data: { username, password }
        });
    }

    static async refresh() {
        return await OAuthAPI.requestAuthenticated({
            endpoint: '/refresh-token',
            method: 'post',
            loading: false,
            noVersion: true
        })
    }

    static async refreshToken(access_token) {
        return await OAuthAPI.request({
            endpoint: "/refresh",
            headers: {
                Authorization: "Bearer " + access_token,
            },
            method: "post",
            loading: false,
            noVersion: true,
        });
    }
}